@if (products && category) {
    <div>
        <div class="row">
            <div class="col-xl-3 d-flex flex-column justify-content-center word-wrap-break-word">
                <h3 class="mb-4 fs-29 fw-700">{{ category.name }}</h3>
                <div>
                    @if (category.description) {
                        <p class="mb-7 lh-29">{{ category.description }}</p>
                    } @else {
                        <p class="mb-7 lh-29">{{ 'NEW_ARRIVALS.teaser' | translate }}</p>
                    }
                </div>
                <div class="d-none d-xl-block">
                    <app-button [url]="['/products', 'category', category.slug] | localize">
                        {{ 'BUTTONS.see_all' | translate }}
                    </app-button>
                </div>
            </div>
            <div class="col-xl-9">
                <div class="d-none d-md-block">
                    <div #swiper class="swiper" [class.is-client]="isClient">
                        <div class="swiper-wrapper">
                            @for (product of products; track product.slug) {
                                <div class="swiper-slide">
                                    <a [routerLink]="['/products', 'category', category.slug, product.slug] | localize">
                                        <div class="item" app-product-thumbnail [product]="product"></div>
                                    </a>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div class="d-md-none">
                    <div class="row gx-0 gx-md-4 gy-4">
                        @for (product of products; track product) {
                            <div class="col-6">
                                <a [routerLink]="['/products', 'category', category.slug, product.slug] | localize">
                                    <div class="item" app-product-thumbnail [product]="product"></div>
                                </a>
                            </div>
                        }
                    </div>
                </div>
                <div #swiperPagination class="pagination mt-6 mb-xl-0"></div>
            </div>
        </div>
        <div class="d-block d-xl-none mt-8">
            <app-button [url]="['/products', 'category', category.slug] | localize">
                {{ 'BUTTONS.see_all' | translate }}
            </app-button>
        </div>
    </div>
} @else {
    <div class="spinner mx-auto"></div>
}
